import { css } from "@emotion/react";

export const centerLayout = css`
  min-height: calc(100vh - 114px);
  flex: 1;
`;
